//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SplitViewOverlay from '~/components/SplitViewOverlay.vue';
import colors from '@/shared/assets/scss/colorsExport.scss';
import observeVisibility from '@/shared/directives/observe-visibility';
import DonutMetric from './Workouts4_DonutMetric.vue';

export default {
  name: 'Workouts4_Format',
  components: {
    SplitViewOverlay,
    DonutMetric,
  },
  directives: {
    observeVisibility,
  },
  data: () => ({
    workoutValue: 0,
    restValue: 0,
    colors,
  }),
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        setTimeout(() => {
          this.restValue = 1;
          this.workoutValue = 3;
        }, 300);
      }
    },
  },
};
